import { YearPicker } from "@mantine/dates";
export const yearPickerProps = YearPicker.extend({});
